module.exports = __webpack_public_path__ + "media/1923-1975.58dcd356.mp4";